import { Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { Step } from '@app/shared/interfaces/step.interface';
import { ChangeStepService } from '../../stepper/service/change-step.service';

@Component({
    selector: 'app-navigation-step',
    standalone: true,
    imports: [CommonModule, TranslateModule, SharedModule, DividerModule],
    templateUrl: './navigation-step.component.html',
    styleUrl: './navigation-step.component.scss',
})
export class NavigationStepComponent {

    @Input() stepIdSelected: any = 0;
    @Input() steps: Step[] = [];


    stepTitle: string = '';
    stepUrlBack: string = '';
    
    stepNumberSelected = 0;

    backButtonDisabled = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeStepService: ChangeStepService,
    ) {}

    ngOnInit() {

        //this.stepIdSelected++;
        this.stepIdSelected = this.changeStepService.currentStepId;

        this.stepNumberSelected = Number(this.steps.find((item) => item.stepId == this.stepIdSelected)?.stepNumber);
        this.stepTitle = this.steps[this.stepIdSelected].stepName;
        this.stepUrlBack = this.steps[this.stepIdSelected].stepUrlBack;

        console.log(this.steps);
        console.log(this.stepIdSelected);
        console.log(this.stepTitle);
        console.log(this.stepUrlBack);


        this.changeStepService.changedStep.subscribe((stepId) => {
            this.stepIdSelected = stepId;

            this.stepNumberSelected = Number(this.steps.find((item) => item.stepId == stepId)?.stepNumber);
            this.stepTitle = String(this.steps.find((item) => item.stepId == stepId)?.stepName);
            this.stepUrlBack = String(this.steps.find((item) => item.stepId == stepId)?.stepUrlBack);
        });

    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.changeStepService.changeStep(this.stepIdSelected);

        this.router.navigate([this.stepUrlBack], { relativeTo: this.route });
    }
}
